import {
    AddCircle16Regular, AppsAddIn16Regular, ArrowClockwise16Regular, ArrowDownload16Regular, ArrowExportLtr16Regular, ArrowSwap16Regular,
    ArrowUndo16Regular, ArrowUpload16Regular, Branch20Regular,
    CircleHint16Regular, Copy16Regular, Delete16Regular, Dismiss16Regular, Flow16Regular, FluentIcon, Group20Regular, History16Regular,
    KeyboardShift16Regular,MoreVertical16Regular, Open16Regular,
    PersonArrowRight16Regular, Search16Regular,
    FlashSettings20Regular, Send16Regular, Wand20Regular,
    BranchFork16Regular, Clock16Regular,
    ClipboardCheckmark16Regular,
} from "@fluentui/react-icons";
import {
    COPY_ICON, UNDO_ICON, MERGE_ICON, DELETE_ICON, NEW_ICON, VERSION_HISTORY_ICON,
    AUTO_MATCH_ICON, TRIGGER_AUTO_ICON, ASSING_TO_ICON, UPDATE_STATUS_ICON, SELECTED_ICON, START_SESSION,
    ALLOCATE_ICON, UNDO_ALLOCATION_ICON, OPEN_IN_NEW_TAB, SUBMIT_ICON, CREATE_NEW_ICON,
    EXPORT_ICON, IMPORT_ICON, MORE_OPTIONS_ICON, SEARCH_ICON, GROUP_ICON, SEND_ICON,
    REFRESH_ICON, DOWNLOAD_ICON, SET_CD_ALLOCATION_SCHEDULE_ICON, PRE_ALLOCATE_ICON, RUN_QA_ICON,
} from "../../Consts";
import { IconKey } from "../../types/IconKey";

export const ICON_REGISTRY: Record<IconKey, FluentIcon> = {
    [DELETE_ICON]: Delete16Regular,
    [NEW_ICON]: AddCircle16Regular,
    [CREATE_NEW_ICON]: AppsAddIn16Regular,
    [UNDO_ICON]: ArrowUndo16Regular,
    [COPY_ICON]: Copy16Regular,
    [SUBMIT_ICON]: KeyboardShift16Regular,
    [MERGE_ICON]: Branch20Regular,
    [AUTO_MATCH_ICON]: Wand20Regular,
    [TRIGGER_AUTO_ICON]: FlashSettings20Regular,
    [VERSION_HISTORY_ICON]: History16Regular,
    [ALLOCATE_ICON]: BranchFork16Regular,
    [SET_CD_ALLOCATION_SCHEDULE_ICON]: Clock16Regular,
    [PRE_ALLOCATE_ICON]: Flow16Regular,
    [RUN_QA_ICON]: ClipboardCheckmark16Regular,
    [UNDO_ALLOCATION_ICON]: ArrowUndo16Regular,
    [EXPORT_ICON]: ArrowExportLtr16Regular,
    [IMPORT_ICON]: ArrowUpload16Regular,
    [MORE_OPTIONS_ICON]: MoreVertical16Regular,
    [ASSING_TO_ICON]: PersonArrowRight16Regular,
    [UPDATE_STATUS_ICON]: CircleHint16Regular,
    [SELECTED_ICON]: Dismiss16Regular,
    [START_SESSION]: Flow16Regular,
    [OPEN_IN_NEW_TAB]: Open16Regular,
    [SEARCH_ICON]: Search16Regular,
    [GROUP_ICON]: Group20Regular,
    [SEND_ICON]: Send16Regular,
    [REFRESH_ICON]: ArrowClockwise16Regular,
    [DOWNLOAD_ICON]: ArrowDownload16Regular,
};

export const resolveIcon = (key?: IconKey): FluentIcon =>
    (key && ICON_REGISTRY[key]) ?? MoreVertical16Regular;
